import React, { useState } from 'react';
import { connect } from 'react-redux';
import qs from 'qs';
import ReactRouter from 'react-router';
import axios from 'axios';
import { Animation } from '@ordermentum/ui-shared/atoms/Animation';
import { invoiceT, supplierT } from '@ordermentum/ui-types';
import { LoginBase } from './LoginBase';
import { Header } from './DefaultLogin';
import { SignUpForm } from './Forms/SignUpForm';
import { SignInForm } from './Forms/LoginForm';
import { RouteParams } from './Forms/index.types';
import { PaymentSuccessBanner } from './Forms/index.styles';

import { handleExportPdf } from '../../redux/actions';
import { RootState } from '../../redux/store';

const SuccessBanner = ({ isInvoice = false }: { isInvoice: boolean }) => (
  <PaymentSuccessBanner>
    <Animation type="success-confetti" size="sm" />
    <h1>Thanks!</h1>
    <p>
      {isInvoice
        ? 'Your payment has been made.'
        : 'Your payment details have now been saved.'}
      <br />
      <br />
      If you’d like, you can create an account or sign in with Ordermentum so
      that you’re able to place orders and manage payments for all of your
      suppliers in one place.
    </p>
  </PaymentSuccessBanner>
);

export const PaymentRequestLogin = (
  props: ReactRouter.RouteComponentProps<RouteParams, {}> & {
    invoice: invoiceT;
    supplier: supplierT;
    handleExportPdf: (paymentRequestId?: string, token?: string) => void;
  }
) => {
  const { params, location } = props;
  const [form, setForm] = useState(
    location.query?.userId ? 'signIn' : 'signUp'
  );

  const { paymentRequestId: id, token, invoiceId } = props.location.query ?? {};

  if (form === 'signIn') {
    return (
      <LoginBase type="default" header={<Header />} {...props}>
        <div>
          <SuccessBanner isInvoice={!!invoiceId} />
          <SignInForm
            onSubmitSuccess={async () => {
              await axios.post(`/v1/payment-requests/${id}/add-user`, {
                token,
              });
            }}
            destination={'/dashboard'}
            onSignUpClick={() => setForm('signUp')}
            {...props}
          />
        </div>
      </LoginBase>
    );
  }

  if (form === 'signUp') {
    return (
      <LoginBase type="default" header={<Header />}>
        <div>
          <SuccessBanner isInvoice={!!invoiceId} />
          <SignUpForm
            registrationSuccessDestination={`/payments/${
              params.retailerId
            }/pending-activation?${qs.stringify({
              paymentRequestId: id,
              token,
            })}`}
            paymentRequestId={id}
            onSignInClick={() => setForm('signIn')}
            {...props}
          />
        </div>
      </LoginBase>
    );
  }

  return null;
};

const mapStateToProps = (state: RootState) => ({
  // @ts-expect-error invoiceDetails never existed in the store
  invoice: state.invoiceDetails?.get('data').toJS(),
});

const mapDispatchToProps = {
  handleExportPdf,
};

const PaymentRequestLoginConnected = connect(
  mapStateToProps,
  mapDispatchToProps
)(PaymentRequestLogin);

export { PaymentRequestLoginConnected };
